import React from 'react'
import './Topbar.css'

const Topbar = () => {
  return (
    <div className="topbar" id="topbar">
      <header>
        <h2>
          <label htmlFor="toggle">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAUklEQVRIS2NkoDFgpLH5DKMWEAxh+gdR84RF/wk6C4+C2oI4FEdj+IDmFlDiemx66R8HNPcBzeOA5hbQPIiGvgU0jwOaWzD042DUB+ghQPPSFAB/NhgZV1e6GAAAAABJRU5ErkJggg==" alt="" />
          </label>
        Dashboard</h2>

        <div className="topbar-search">
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABqElEQVRIS7WU3VXCQBCF7wTftQStQK1A7CAUQCINSPJOIJgCEisAYgHGCowdQAVaArybjGfzJ8IGNgL7lpPd/e7cvTOEEy868f2QAlx/ctHSzvrgVAfoJhfBc5AWJen3s2v3lqrCtgBPfvhABB/ARc0lS2bYQ9uYqkD+AIrLJ5lexhuBAsfuxuLb81/aALsg3OUFUcexu9E+SAXIbKHWp1DOjF6dQs+fuSAaAVgmnFzts6sClAeF8qFt6LuUeX4YZ5Uwjx3bdHftXQOEcxCuwXRf2lJ3MLOL+F08vGOZt2qAIGSx0bEMpeh6ivt/K1A8UKptDvAbWaSD+BWMhWMbRZ/Ijdp6ZACRYxmdoz9yFlNoXyA6B5Hr9LtjGaSKKfMqQXqpHNOimfLS8xWzBnf4aHxUjUYs8t/OG21/RMU2+agAB1klssW8AiD+j0RMiRAM+uasztL6YQfNAkjPeiNTjAXAUYI0ELZ4ZShyldOBZfRkEKXMyw6uz63CCink34DiXaYgNksBskoOAqhADgZsQjYn8VEAJYTB8eaYPxqgUUx3jYmm/05ewQ+R29MZlmOE3QAAAABJRU5ErkJggg==" alt="" />
          <input type="search" name="" id="" placeholder="Type here" />
        </div>

        <div className="topbar-user">
          <img src={process.env.PUBLIC_URL + '/shamaayilahmed.jpg'} alt="user" style={{ width: '40px', height: '40px' }} />
          <div className="">
            <h4>Shamaayil</h4>
            <small>Admin</small>
          </div>
        </div>
      </header>
    </div >
  )
}

export default Topbar
